import React from "react";

import TAMMaterial from "../materials/TAMMaterial";

import ToonMaterial from "../materials/ToonMaterial";

import GoochMaterial from "../materials/GoochMaterial";

import HalftoneMaterial from "../materials/HalftoneMaterial";

import OutlineMaterial from "../materials/OutlineMaterial";

import PBRMaterial from "../materials/PBRMaterial";

export default function TechniqueRenderer({
  technique,

  surface,
  lighting,

  tam,
  hatching,
  toon,
  gooch,
  halftone,
  outline,
  pbr,
}) {
  const sharedLighting = {
    lightColor: lighting.color,

    lightIntensity: lighting.intensity,

    ambientIntensity: lighting.ambient,

    lightDirection: lighting.direction,
  };

  switch (technique) {
    case "hatching":
      return (
        <TAMMaterial
          tam={tam}
          surface={surface}

          inkColor={hatching.inkColor}

          hatchScale={hatching.hatchScale}

          {...sharedLighting}
        />
      );

    case "toon":
      return (
        <ToonMaterial
          surface={surface}

          bands={toon.bands}

          {...sharedLighting}
        />
      );

    case "gooch":
      return (
        <GoochMaterial
          surface={surface}

          coolColor={gooch.coolColor}

          warmColor={gooch.warmColor}

          coolMix={gooch.coolMix}

          warmMix={gooch.warmMix}

          {...sharedLighting}
        />
      );

    case "halftone":
      return (
        <HalftoneMaterial
          surface={surface}

          inkColor={halftone.inkColor}

          dotScale={halftone.dotSize}

          dotAngle={(halftone.angle * Math.PI) / 180}

          softness={halftone.softness}

          {...sharedLighting}
        />
      );

    case "outline":
      return (
        <OutlineMaterial
          surface={surface}

          lineColor={outline.lineColor}

          silhouetteWidth={outline.silhouetteWidth}

          detailStrength={outline.detailStrength}

          shadingStrength={outline.shadingStrength}

          {...sharedLighting}
        />
      );

    case "pbr":
      return (
        <PBRMaterial
          surface={surface}

          metallic={pbr.metallic}

          metallicMap={pbr.metallicMap}

          roughness={pbr.roughness}

          roughnessMap={pbr.roughnessMap}

          {...sharedLighting}
        />
      );

    default:
      return null;
  }
}
